import api from 'api';
import storage from "@/cflow/storageService";

class EstoqueService {

    listar(dados, lab_id, skiped) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/estoque?lab_id='+lab_id+'&skiped='+skiped+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/estoque?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/estoque/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/estoque/' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new EstoqueService();